const ReceiptLongIcon = (
  <svg
    className="fill-current"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m21 6.243a3.975 3.975 0 0 0-1.172-2.829l-2.242-2.242A4.022 4.022 0 0 0 14.758 0H6a3 3 0 0 0-3 3v21h18zm-2.586-1.415A1.923 1.923 0 0 1 18.555 5H16V2.445a1.923 1.923 0 0 1 .172.141zM5 22V3a1 1 0 0 1 1-1h8v5h5v15zm3-13h8v2H8zm0 4h8v2H8zm6.018 3.814 1.965.366c-.191 1.047-1.005 2.82-2.848 2.82a3.154 3.154 0 0 1-1.986-.706c-.314-.223-.424-.294-.662-.294a2.18 2.18 0 0 0-.916.66l-1.5-1.317A3.749 3.749 0 0 1 10.487 17a2.925 2.925 0 0 1 1.821.664 1.235 1.235 0 0 0 .827.336c.623 0 .88-1.173.883-1.186z"
      fill="currentColor"
    />
  </svg>
);

export default ReceiptLongIcon;